module.exports = __webpack_public_path__ + "static/img/medel_active.63062659.png";